<template>
    <el-row>
        <el-dialog
                style="text-align: left"
                @closed="createDialogClosed"
                :visible.sync="show"
                title="创建工厂信息"
                width="50%">
            <el-form ref="createFactory" label-width="100px" :rules="rules" :model="createFactoryFormData">
                <el-form-item :rules="rules.requiredRules" prop="name" label="名称:" size="mini">
                    <el-input v-model="createFactoryFormData.name"></el-input>
                </el-form-item>
                <el-form-item
                        prop="tel" label="电话:" :rules="rules.requiredRules" size="mini">
                    <el-input v-model="createFactoryFormData.tel"></el-input>
                </el-form-item>
                <el-form-item prop="address" label="地址:" size="mini">
                    <el-input v-model="createFactoryFormData.address"></el-input>
                </el-form-item>
                <el-form-item :rules="rules.requiredRules" size="mini" prop="is_using" label="是否停用:">
                    <el-select v-model="createFactoryFormData.is_using">
                        <el-option :value="false" label="停用"></el-option>
                        <el-option :value="true" label="未停用"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-row style="margin: 10px 0">
                <el-button :loading="createFactoryLoading" @click="createNewFactory" type="primary" size="mini">完成
                </el-button>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="show = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-table :data="produceFactories">
            <el-table-column prop="name" label="名称"/>
            <el-table-column prop="created" label="创建时间"/>
            <el-table-column prop="tel" label="电话"/>
            <el-table-column prop="address" label="地址"/>
            <el-table-column label="是否停用">
                <template slot-scope="{ row }">
                    <el-tag v-if="!row.is_using" size="mini" type="danger">停用</el-tag>
                </template>
            </el-table-column>
        </el-table>

        <el-row style="margin: 10px 0;text-align: left">
            <el-button @click="show=true" size="mini" type="primary">新增工厂信息</el-button>
        </el-row>
    </el-row>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "FactorySetup",
        data() {
            return {
                show: false,
                factoriesUrl: this.$const.factoriesUrl,
                createFactoryLoading: false,
                createFactoryFormData: {
                    name: '',
                    tel: '',
                    address: '',
                    is_using: true,
                },

                rules: {
                    requiredRules: [
                        {required: true, message: '必填项', trigger: 'blur'}
                    ],

                },
            }
        },
        computed: {


            ...mapState(['produceFactories'])
        },
        methods: {
            /**
             * 创建工厂信息
             */
            createNewFactory() {
                this.$refs.createFactory.validate((validated => {
                    if (validated) { // 表单验证通过
                        this._sendCreateNewFactory()
                    }
                }))
            },

            _sendCreateNewFactory() {
                this.createFactoryLoading = true
                this.$postRequest(this.factoriesUrl, this.createFactoryFormData)
                    .then(response => {
                        this.createFactoryLoading = false
                        const newFactories = this.produceFactories.concat([response.data])
                        this.setProduceFactories(newFactories)
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '创建成功'
                        })
                        this.show = false
                    })
                    .catch(() => {
                        this.createFactoryLoading = false
                    })
            },

            /**
             * 关闭创建工厂对话框后的事件
             */
            createDialogClosed() {
                this.createFactoryFormData.name = ''
                this.createFactoryFormData.tel = ''
                this.createFactoryFormData.address = ''
                this.createFactoryFormData.is_using = true
            },

            /**
             * 加载工厂信息
             */
            loadProduceFactories() {
                if (this.produceFactories.length <= 0) {
                    this.$getRequest(this.factoriesUrl)
                        .then(response => {
                            this.setProduceFactories(response.data)
                        })
                        .catch()
                }
            },

            ...mapMutations(['setProduceFactories'])
        },
        created() {
            this.loadProduceFactories()
        }
    }
</script>

<style scoped>

</style>